import axios from 'axios'

const API_URL = process.env.REACT_APP_BASE_API_URL

const GET_ALL_CHAT_THREADS = `${API_URL}/ai-chat-threads`
const CREATE_CHAT_THREADS = `${API_URL}/ai-chats`
const GET_CHATS_FROM_THREAD = `${API_URL}/ai-chat-threads`

export const getAllChatThreads = (companyId: any,isRecordKeeper?:boolean) => {
  return axios.get(`${GET_ALL_CHAT_THREADS}${isRecordKeeper ? `?isRecordsKeeperAI=${isRecordKeeper}`:''}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true // Accept all status codes
    },
  })
}

export const createChatThread = async (payload: any, companyId: any,isRecordKeeper?:boolean) => {
  return axios.post(`${CREATE_CHAT_THREADS}${isRecordKeeper ? `?isRecordsKeeperAI=${isRecordKeeper}`:''}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true // Accept all status codes
    },
  })
}

export const getChatsFromThread = (threadId: any, companyId: any,isRecordKeeper?:boolean) => {
  return axios.get(`${GET_CHATS_FROM_THREAD}/${threadId}/ai-chats${isRecordKeeper ? `?isRecordsKeeperAI=${isRecordKeeper}`:''}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateChatThreadTitle = async (threadId: any, payload: any, companyId: any,isRecordKeeper?:boolean) => {
  return axios.post(`${GET_CHATS_FROM_THREAD}/${threadId}${isRecordKeeper ? `?isRecordsKeeperAI=${isRecordKeeper}`:''}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true // Accept all status codes
    },
  })
}

export const deleteChatThread = async (threadId: any, companyId: any,isRecordKeeper?:boolean) => {
  return axios.delete(`${GET_CHATS_FROM_THREAD}/${threadId}${isRecordKeeper ? `?isRecordsKeeperAI=${isRecordKeeper}`:''}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true 
    },
  })
}
